import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDBXBg80oPW4Oxc4rqKhMqT9CboBZIsx1k",
    authDomain: "jynperez-1aa21.firebaseapp.com",
    projectId: "jynperez-1aa21",
    storageBucket: "jynperez-1aa21.firebasestorage.app",
    messagingSenderId: "457240724776",
    appId: "1:457240724776:web:d4704fc4f5de9ac13e3c1d",
    measurementId: "G-5EHJ7X0EL1",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export default app;
